export const loginSelfRedirectPaths = [
  '/auth/affiliate-invite',
  '/auth/user-invite'
]
